import React, { useEffect, useState } from 'react';
import SwipeToTrade from './SwipeToTrade';
import { createSwipeChallenge, rerollSwipeGestures } from '../utils/swipeChallenge';

const SwipeTradeActions = ({ disabled = false, resetKey, buy = null, sell = null }) => {
  const hasBuy = !!buy;
  const hasSell = !!sell;

  const [challenge, setChallenge] = useState(() => createSwipeChallenge({ hasBuy, hasSell }));

  useEffect(() => {
    setChallenge(createSwipeChallenge({ hasBuy, hasSell }));
  }, [resetKey, hasBuy, hasSell]);

  const handleFail = () => {
    if (disabled) return;
    setChallenge((current) => rerollSwipeGestures(current, { hasBuy, hasSell }));
  };

  return (
    <div className="bottom-actions bottom-actions-swipe">
      {challenge.order.map((side) => {
        const config = side === 'buy' ? buy : sell;
        const gesture = side === 'buy' ? challenge.buy : challenge.sell;
        if (!config || !gesture) return null;

        return (
          <SwipeToTrade
            key={`${challenge.id}-${side}`}
            variant={side}
            label={config.label}
            hint={config.hint || ''}
            disabled={disabled}
            direction={gesture.direction}
            confirmRatio={gesture.confirmRatio}
            onConfirm={config.onConfirm}
            onFail={handleFail}
          />
        );
      })}
    </div>
  );
};

export default SwipeTradeActions;
